import HotelRoomMappingType from '@app/model/market_state/HotelRoomMappingType';
import Price from '@app/model/market_state/Price';

export type MarketStateStatDateCompetitorAvailabilityEvolutionRoomItem = {
	roomId: number;
	roomName: string;
	availability: number;
	price?: Price;
}

export default class MarketStateStatDateCompetitorAvailabilityEvolutionItem {
	hotelId: number;
	roomMappingType: HotelRoomMappingType;
	availability: number;
	representativeRoomId: number | undefined;
	roomItems: MarketStateStatDateCompetitorAvailabilityEvolutionRoomItem[];

	constructor(data: MarketStateStatDateCompetitorAvailabilityEvolutionItem) {
		Object.assign(this, data);
	}
}
